document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName('js-text-copy-toggler')
  for (const element of elements) {
    const copyButton = element.querySelector('button.js-text-copy-toggler-button')
    const textInput = element.querySelector('input.js-text-copy-toggler-input');

    copyButton.addEventListener('click', () => {
      copyToClipboard(textInput.value)
    })

    function copyToClipboard (value) {
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(value).then(function () {
          copyButton.classList.add('is-success');
          setTimeout(() => {
            copyButton.classList.remove('is-success');
          }, 500);
        })
      } else {
        textInput.select()
        document.execCommand('copy')
        copyButton.classList.add('is-success');
        setTimeout(() => {
          copyButton.classList.remove('is-success');
        }, 500);
      }
    }
  }
});